module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Connect Device","userCode":"Bekreftelseskode (9 siffer)","infoMessage":"Skriv in koden som visas på din enhet. Fortsett bare hvis di øverenstemmer"},"en":{"title":"Connect Device","userCode":"Verification code (9 digits)","infoMessage":"Enter the code displayed on your device"}}')
  delete Component.options._Ctor
}
